export default {
  ja:[
    "メールアドレス",
    "id",
    "name",
    "お住まいの国を選択してください",
    "パスワード",
    "パスワード確認",
    "利用規約",
    "プライパシーポリシー",
    "に同意する。",
    "戻る",
    "サインアップ",
  ],
  en: [
    "email",
    "id",
    "name",
    "Chose your country",
    "password",
    "password confirm",
    "Terms of service",
    "Privacy policy",
    "Accept",
    "back",
    "sign up",
  ]
}
